import React from 'react'

export default () => {
	return (
		<footer>&copy;Barito of PGIN-ITO 2019. All rights reserved. 
			<br />Designed By Karen Rai. Developed By John Carl James Nebab</footer>
	)
}
